import './WhatYouGet.css';
import { useEffect, useState } from 'react';
import { useWhatYouGetContent } from '../../../context/ContentContext';
import greendotTick from '../../../assets/images/greendot_tick.svg';

const WhatYouGet = () => {
    const [isMobile, setIsMobile] = useState(() => {
        if (typeof window === 'undefined') return false;
        return window.innerWidth < 768;
    });

    useEffect(() => {
        if (typeof window === 'undefined') return undefined;

        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const content = useWhatYouGetContent();

    if (!content) return null;

    const { eyebrow, headline, price, subtext, basePlanLabel, features, featuresMobile } = content;
    const shouldHighlightDistribution =
        `${headline?.line1 || ''} ${headline?.line2 || ''}`.replace(/\s+/g, ' ').trim() ===
        'Unlimited Global Distribution';

    // Split features into two columns
    const mid = isMobile ? Math.ceil(featuresMobile.length / 2) : Math.ceil(features.length / 2);
    const leftFeatures = isMobile ? featuresMobile.slice(0, mid) : features.slice(0, mid);
    const rightFeatures = isMobile ? featuresMobile.slice(mid) : features.slice(mid);

    return (
        <section className="what-you-get-section" id='what-you-get'>
            <div className="what-you-get max-width">
                <div className="wyg-header">
                    <p className="wyg-eyebrow">{eyebrow}</p>
                    <h2 className="wyg-headline">
                        {headline.line1}<br />
                        {shouldHighlightDistribution ? (
                            <span className="wyg-headline-highlight">{headline.line2}</span>
                        ) : (
                            headline.line2
                        )}
                        {headline.line3 && (
                            <>
                                <br />
                                {headline.line3}
                            </>
                        )}
                        {price && <span className="wyg-price"> {price}</span>}
                    </h2>
                    {subtext && <p className="wyg-subtext">{subtext}</p>}
                </div>

                <div className="wyg-card">
                    {basePlanLabel && <p className="wyg-base-plan-label">{basePlanLabel}</p>}
                    <div className="wyg-features-grid">
                        <ul className="wyg-feature-col">
                            {leftFeatures.map((item, i) => (
                                <li key={i} className="wyg-feature-item">
                                    <img src={greendotTick} alt="check" className="wyg-tick" />
                                    <div className="wyg-feature-text">
                                        <span className="wyg-feature-title">{item.title}</span>
                                        <span className="wyg-feature-desc">{item.description}</span>
                                    </div>
                                </li>
                            ))}
                        </ul>
                        <ul className="wyg-feature-col">
                            {rightFeatures.map((item, i) => (
                                <li key={i} className="wyg-feature-item">
                                    <img src={greendotTick} alt="check" className="wyg-tick" />
                                    <div className="wyg-feature-text">
                                        <span className="wyg-feature-title">{item.title}</span>
                                        <span className="wyg-feature-desc">{item.description}</span>
                                    </div>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>

            </div>
        </section>
    );
};

export default WhatYouGet;
